"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { BoolControl, BoolTableControl, DateControl, DateTwinControl, IsBlankControl, IsNotBlankControl, MultiSelectControl, NumberControl, NumberTwinControl, SelectControl, TextControl, DateFromToControl, AnyOfControl } from 'D5Utils/form_fields';
import { System } from "Constants/objects";

var FieldsFactory =
/*#__PURE__*/
function () {
  function FieldsFactory() {
    _classCallCheck(this, FieldsFactory);
  }

  _createClass(FieldsFactory, null, [{
    key: "create",
    value: function create(type, props) {
      var Control = null;

      switch (type) {
        case System.FIELD_EDITOR_TYPE.BOOL_CB:
          Control = BoolControl;
          break;

        case System.FIELD_EDITOR_TYPE.BOOL_SB:
          Control = BoolTableControl;
          break;

        case System.FIELD_EDITOR_TYPE.DATE:
        case System.FIELD_EDITOR_TYPE.DATETIME:
          Control = DateControl;

          if (props.displayType === 4) {
            Control = DateFromToControl;
          }

          break;

        case System.FIELD_EDITOR_TYPE.DATE_TWIN:
          Control = DateTwinControl;
          break;

        case System.FIELD_EDITOR_TYPE.MULTI_SELECT:
          Control = MultiSelectControl;
          break;

        case System.FIELD_EDITOR_TYPE.NUMBER:
          Control = NumberControl;
          break;

        case System.FIELD_EDITOR_TYPE.NUMBER_TWIN:
          Control = NumberTwinControl;
          break;

        case System.FIELD_EDITOR_TYPE.SELECT:
          Control = SelectControl;
          break;

        case System.FIELD_EDITOR_TYPE.TEXT:
          Control = TextControl;
          break;

        case System.FIELD_EDITOR_TYPE.IS_BLANK:
          Control = IsBlankControl;
          break;

        case System.FIELD_EDITOR_TYPE.IS_NOT_BLANK:
          Control = IsNotBlankControl;
          break;

        case System.FIELD_EDITOR_TYPE.ANY_OF:
          Control = AnyOfControl;
          break;

        default:
          Control = TextControl;
      }

      var control = new Control(props);
      control.render();
      return control;
    }
  }]);

  return FieldsFactory;
}();

export { FieldsFactory as default };